import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSearch = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M21.0006 21L15.5186 15.518",
		stroke: "#636C7B",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10.3333 17.6667C14.3834 17.6667 17.6667 14.3834 17.6667 10.3333C17.6667 6.28325 14.3834 3 10.3333 3C6.28325 3 3 6.28325 3 10.3333C3 14.3834 6.28325 17.6667 10.3333 17.6667Z",
		stroke: "#636C7B",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	})]
});
export default SvgSearch;
